/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */
import React, { useEffect } from "react";
import { WithPreview } from "@quintype/components";
import { number, object, shape, any } from "prop-types";

import TaboolaScript from "../../ads/taboola-ad/load-taboola-ad";

import Bredcrum from "../../story-templates/story-header/bredcrums";
import TextStory from "../../story-templates/text";
import VideoStory from "../../story-templates/video";
import PodCastStory from "../../story-templates/podcast";
import PhotoStory from "../../story-templates/photo";
import ListcleStory from "../../story-templates/listcle";
import LiveBlogStory from "../../story-templates/live-blog";
import ExclusiveStory from "../../story-templates/exclusive";
import CartoonStory from "../../story-templates/cartoon";
import PanchangaStory from "../../story-templates/panchanga";
import HoroscopeStory from "../../story-templates/horoscope";
import SocialMediaShare from "../../molecules/social-media-share";

import "./story.m.css";

const pickTemplate = {
  text: TextStory,
  video: VideoStory,
  photo: PhotoStory,
  podcast: PodCastStory,
  cartoon: CartoonStory,
  listicle: ListcleStory,
  panchanga: PanchangaStory,
  horoscope: HoroscopeStory,
  "live-blog": LiveBlogStory,
  "fact-check": TextStory,
  "pv-exclusive": ExclusiveStory,
  "movie-review": TextStory,
  "gadget-review": TextStory,
  "sponsored-story": TextStory
};
function StoryPageBase({ index = 0, story, initialPath }) {
  const Component = pickTemplate[story["story-template"]] || TextStory;
  const isPremiumStory = story?.access === "subscription";

  useEffect(() => {
    const containerEl = document.getElementById("container");
    if (containerEl) {
      containerEl.style.backgroundColor = isPremiumStory ? "#FFF8E8" : "";
    }
    return () => {
      const containerEl = document.getElementById("container");
      if (containerEl) containerEl.style.backgroundColor = "";
    };
  }, [isPremiumStory]);

  let taboolaCategoryType;

  switch (story["story-template"]) {
    case "video":
      taboolaCategoryType = "video";
      break;
    case "video-playlist":
      taboolaCategoryType = "video";
      break;
    case "podcast":
      taboolaCategoryType = "video";
      break;
    case "photo":
      taboolaCategoryType = "photo";
      break;
    default:
      taboolaCategoryType = "article";
  }

  return (
    <div styleName="story-wrapper" className="container" style={isPremiumStory ? { backgroundColor: "#FFF8E8" } : {}}>
      <TaboolaScript type={taboolaCategoryType} />
      {index === 0 && <Bredcrum initialPath={initialPath} story={story} type="story-page" />}
      <Component story={story} index={index} />
    </div>
  );
}

StoryPageBase.propTypes = {
  index: number,
  story: object,
  otherProp: any
};
export function StoryPage(props) {
  const preventCopyHandler = (event) => event.preventDefault();

  return (
    <div onCopy={preventCopyHandler}>
      <StoryPageBase {...props.data} initialPath={props.currentPath} />
    </div>
  );
}

StoryPage.propTypes = {
  data: shape({
    story: object
  })
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    relatedStories: Array(5).fill(story)
  })
);
